import { render, staticRenderFns } from "./ColorFlavor.vue?vue&type=template&id=3a62af04&scoped=true&"
import script from "./ColorFlavor.vue?vue&type=script&lang=js&"
export * from "./ColorFlavor.vue?vue&type=script&lang=js&"
import style0 from "./ColorFlavor.vue?vue&type=style&index=0&id=3a62af04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62af04",
  null
  
)

export default component.exports